import { Waypoint } from 'react-waypoint';
import { useState } from 'react';
import { Text, Cell, Image } from '@vinted/web-ui';
import { FormattedRelativeTime } from 'components/@support';
import { InboxNotificationType } from 'constants/inbox-notification';
import { VINTED_LOGO_IMAGE_PATH } from 'constants/images';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const InboxNotificationItem = _ref => {
  let {
    notification,
    onClick,
    onEnter,
    defaultHighlighted
  } = _ref;
  // we are using `useState` to protect `isHighlighted` from unwanted `defaultHighlighted` changes
  // so the setter is unused
  // eslint-disable-next-line react/hook-use-state
  const {
    0: isHighlighted
  } = useState(defaultHighlighted);

  const renderImage = () => /*#__PURE__*/_jsx(Image, {
    src: notification.photoUrl,
    fallbackSrc: notification.type === InboxNotificationType.Braze ? VINTED_LOGO_IMAGE_PATH : undefined,
    size: Image.Size.Large,
    styling: notification.photoStyle // TODO: check if we can use single style, rather than dynamic

  });

  const renderBody = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      text: notification.body,
      html: true,
      width: Text.Width.Parent
    }), !!notification.note && /*#__PURE__*/_jsx(Text, {
      type: Text.Type.Subtitle,
      width: Text.Width.Parent,
      text: notification.note,
      html: true
    }) // TODO: check if this is needed
    , /*#__PURE__*/_jsx(Text, {
      text: /*#__PURE__*/_jsx(FormattedRelativeTime, {
        value: notification.time
      }),
      type: Text.Type.Subtitle,
      width: Text.Width.Parent
    })]
  });

  return /*#__PURE__*/_jsx(Waypoint, {
    onEnter: onEnter,
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Cell, {
        type: notification.link ? Cell.Type.Navigating : undefined,
        onClick: onClick,
        highlighted: isHighlighted,
        prefix: renderImage(),
        body: renderBody(),
        url: notification.link || undefined,
        testId: "user-notification-item".concat(isHighlighted ? '-highlighted' : '')
      })
    })
  });
};

export default InboxNotificationItem;